import { PropsWithChildren } from 'react'

import { Progress } from '~/shared/components/Progress'
import { ProgressAnalyzerStyles as S } from '~/shared/components/ProgressAnalyzer/styles'
import { COLORS } from '~/shared/constants/uiConstants'

interface Props {
  value: number
  color: string
  numberValue?: number
}

const ProgressAnalyzer = ({
  children,
  value,
  color,
  numberValue,
}: PropsWithChildren<Props>) => (
  <S.Wrapper>
    <S.Text>{children}</S.Text>

    <S.ProgressRow>
      <S.ProgressWrapper>
        <Progress
          $background={COLORS.WHITE}
          color={color}
          value={value}
          max={100}
        />
      </S.ProgressWrapper>

      <S.Value>{numberValue ?? value}%</S.Value>
    </S.ProgressRow>
  </S.Wrapper>
)

export default ProgressAnalyzer
